export const TRAIN_OPTION = Object.freeze({
	DATE: '날짜',
	TIME: '출발 시각',
	DEPART: '출발',
	ARRIVE: '도착',
	DEPART_ENG: 'depart',
	ARRIVE_ENG: 'arrive',
	BUS: '버스',
	TRAIN: '기차',
	MILYANG: '밀양',
	BUSAN: '부산',
});

export const SLIDE_INFO = {
	LENGTH: 3,
	DELAY: 3,
	DETAILS: [
		{
			type: 0,
			link: '/train',
			content: '환승 시간표 확인하기',
		},
		{
			type: 1,
			link: '/bus',
			content: '버스 시간표 확인하기',
		},
	],
};

export const TRAIN_OPTION_EXPLAIN = Object.freeze({
	DATE: `언제 출발하시나요? 최대 일주일 후의 날짜까지 조회 가능해요!`,
	TIME: `출발하기 원하는 시각을 골라주세요!`,
	BUS: `버스 탑승 날짜에 운행하는 버스를 선택해주세요.`,
});

export const STATIONS = {
	POPULAR_LABEL: '자주 찾는 역',
	ALL_LABEL: '역',
	POPULAR: [
		{ name: '서울' },
		{ name: '부산' },
		{ name: '밀양' },
		{ name: '동대구' },
	],
	ALL: [
		{ name: '서울' },
		{ name: '부산' },
		{ name: '밀양' },
		{ name: '동대구' },
		{ name: '동대구' },
	],
};

export const MAP_OPTIONS = {
	INIT_PLACE: '부산대학교 밀양캠퍼스',
	MAP_INIT_LAT: 35.45373762287106,
	MAP_INIT_LNG: 128.806692348998,
	MAP_LEVEL: 5,
	RESULT_MAP_LEVEL: 7,
};

export const BUS_SCHEDULE = {
	station: {
		weekday: [
			{ line: '7', time1: '07:02', time2: '07:18', time3: '07:25' },
			{ line: '2', time1: '07:20', time2: '07:32', time3: '07:39' },
			{ line: '2', time1: '07:37', time2: '07:56', time3: '08:03' },
			{ line: '2', time1: '08:40', time2: '08:52', time3: '08:59' },
			{ line: '1', time1: '08:57', time2: '09:12', time3: '09:19' },
			{ line: '7', time1: '09:06', time2: '09:20', time3: '09:27' },
			{ line: '1', time1: '09:46', time2: '10:00', time3: '10:07' },
			{ line: '2', time1: '09:58', time2: '10:12', time3: '10:19' },
			{ line: '4-1', time1: '10:16', time2: '10:30', time3: null },
			{ line: '2', time1: '10:38', time2: '10:52', time3: '10:59' },
			{ line: '7-1', time1: '12:00', time2: '12:16', time3: '12:23' },
			{ line: '1-2', time1: '12:18', time2: '12:34', time3: '12:41' },
			{ line: '2', time1: '13:05', time2: '13:16', time3: '13:23' },
			{ line: '1', time1: '13:28', time2: '13:44', time3: '13:51' },
			{ line: '1', time1: '13:50', time2: '14:00', time3: '14:07' },
			{ line: '7', time1: '14:30', time2: '14:40', time3: '14:47' },
			{ line: '4-1', time1: '15:20', time2: '15:30', time3: null },
			{ line: '1', time1: '15:28', time2: '15:44', time3: '15:51' },
			{ line: '1', time1: '15:52', time2: '16:00', time3: '16:07' },
			{ line: '4-1', time1: '16:19', time2: '16:28', time3: null },
			{ line: '2', time1: '17:02', time2: '17:16', time3: '17:23' },
			{ line: '2', time1: '17:42', time2: '17:56', time3: '18:03' },
			{ line: '7', time1: '17:58', time2: '18:08', time3: '18:15' },
			{ line: '7-1', time1: '18:22', time2: '18:32', time3: '18:39' },
			{ line: '2', time1: '18:42', time2: '19:00', time3: '19:07' },
			{ line: '7-1', time1: '19:08', time2: '19:24', time3: '19:31' },
			{ line: '1', time1: '19:42', time2: '19:50', time3: '19:57' },
			{ line: '2', time1: '20:04', time2: '20:18', time3: '20:25' },
			{ line: '7', time1: '20:20', time2: '20:30', time3: '20:37' },
			{ line: '7', time1: '20:57', time2: '21:07', time3: '21:14' },
			{ line: '4-1', time1: '21:17', time2: '21:28', time3: null },
			{ line: '2', time1: '22:12', time2: '22:24', time3: '22:31' },
			{ line: '2', time1: '22:44', time2: '23:00', time3: '23:07' },
			{ line: '2', time1: '23:12', time2: '23:20', time3: '23:27' },
		],
		vacation: [
			{ line: '7', time1: '07:02', time2: '07:18', time3: '07:25' },
			{ line: '2', time1: '07:20', time2: '07:32', time3: '07:39' },
			{ line: '2', time1: '07:37', time2: '07:56', time3: '08:03' },
			{ line: '2', time1: '08:39', time2: '08:52', time3: '08:59' },
			{ line: '1', time1: '08:57', time2: '09:12', time3: '09:19' },
			{ line: '1', time1: '09:46', time2: '10:00', time3: '10:07' },
			{ line: '2', time1: '10:38', time2: '10:52', time3: '10:59' },
			{ line: '1-2', time1: '12:18', time2: '12:34', time3: '12:41' },
			{ line: '1', time1: '13:28', time2: '13:44', time3: '13:51' },
			{ line: '1', time1: '13:50', time2: '14:00', time3: '14:07' },
			{ line: '1', time1: '15:28', time2: '15:44', time3: '15:51' },
			{ line: '1', time1: '15:52', time2: '16:00', time3: '16:07' },
			{ line: '2', time1: '17:02', time2: '17:16', time3: '17:23' },
			{ line: '2', time1: '17:42', time2: '17:56', time3: '18:03' },
			{ line: '2', time1: '18:42', time2: '19:00', time3: '19:07' },
			{ line: '7-1', time1: '18:22', time2: '18:32', time3: '18:39' },
			{ line: '7-1', time1: '19:08', time2: '19:24', time3: '19:31' },
			{ line: '2', time1: '20:04', time2: '20:18', time3: '20:25' },
			{ line: '2', time1: '22:44', time2: '23:00', time3: '23:07' },
		],
		holiday: [
			{ line: '2', time1: '07:20', time2: '07:35', time3: '07:42' },
			{ line: '1', time1: '08:40', time2: '09:05', time3: '09:12' },
			{ line: '1', time1: '08:57', time2: '09:10', time3: '09:17' },
			{ line: '2', time1: '10:38', time2: '10:55', time3: '11:02' },
			{ line: '1', time1: '12:18', time2: '12:40', time3: '12:47' },
			{ line: '2', time1: '13:28', time2: '13:45', time3: '13:52' },
			{ line: '2', time1: '15:28', time2: '15:45', time3: '15:52' },
			{ line: '1', time1: '15:47', time2: '16:00', time3: '16:07' },
			{ line: '2', time1: '17:02', time2: '17:15', time3: '17:22' },
			{ line: '2', time1: '17:42', time2: '18:00', time3: '18:07' },
			{ line: '1-2', time1: '18:20', time2: '18:30', time3: '18:37' },
			{ line: '2', time1: '18:42', time2: '18:55', time3: '19:02' },
			{ line: '7-1', time1: '19:08', time2: '19:24', time3: '19:31' },
			{ line: '1', time1: '20:04', time2: '20:18', time3: '20:25' },
			{ line: '1', time1: '20:40', time2: '20:48', time3: '20:55' },
			{ line: '1', time1: '21:34', time2: '21:44', time3: '21:51' },
			{ line: '1', time1: '22:38', time2: '22:50', time3: '22:57' },
		],
	},
	campus: {
		weekday: [
			{ line: '1', time1: '06:14', time2: '06:45', time3: '06:57' },
			{ line: null, time1: null, time2: '07:00', time3: '07:12' },
			{ line: '2', time1: '06:19', time2: '07:20', time3: '07:32' },
			{ line: '1', time1: '08:10', time2: '08:20', time3: '08:32' },
			{ line: '2', time1: '08:33', time2: '08:45', time3: '08:53' },
			{ line: '6', time1: '08:45', time2: '08:56', time3: '09:04' },
			{ line: '1', time1: '09:25', time2: '09:35', time3: '09:43' },
			{ line: '1', time1: '09:41', time2: '09:48', time3: '09:56' },
			{ line: '2', time1: '09:53', time2: '10:05', time3: '10:13' },
			{ line: '2', time1: '10:15', time2: '10:22', time3: '10:32' },
			{ line: '7', time1: null, time2: '11:26', time3: '11:38' },
			{ line: '1', time1: '11:33', time2: '11:48', time3: '11:56' },
			{ line: '7', time1: null, time2: '12:36', time3: '12:48' },
			{ line: '2', time1: '12:41', time2: '12:50', time3: '13:02' },
			{ line: '2', time1: '13:29', time2: '13:36', time3: '13:48' },
			{ line: '2', time1: '14:05', time2: '14:17', time3: '14:29' },
			{ line: '7', time1: null, time2: '14:36', time3: '14:48' },
			{ line: '1', time1: '14:53', time2: '15:05', time3: '15:17' },
			{ line: '1', time1: '15:29', time2: '15:40', time3: '15:52' },
			{ line: '1', time1: '15:53', time2: '16:00', time3: '16:17' },
			{ line: '2', time1: '16:33', time2: '16:42', time3: '16:54' },
			{ line: '1', time1: '17:15', time2: '17:23', time3: '17:35' },
			{ line: '2', time1: '17:29', time2: '17:44', time3: '17:56' },
			{ line: '7', time1: null, time2: '17:45', time3: '17:57' },
			{ line: '1', time1: '17:57', time2: '18:10', time3: '18:22' },
			{ line: '6', time1: '18:37', time2: '18:45', time3: '18:57' },
			{ line: '1', time1: '19:17', time2: '19:30', time3: '19:42' },
			{ line: '6', time1: '19:35', time2: '19:44', time3: '19:56' },
			{ line: '1', time1: '20:01', time2: '20:08', time3: '20:20' },
			{ line: '2', time1: '20:35', time2: '20:45', time3: '20:57' },
			{ line: '1', time1: '20:53', time2: '21:05', time3: '21:17' },
			{ line: '2', time1: '21:50', time2: '21:57', time3: '22:09' },
			{ line: '1', time1: '22:13', time2: '22:22', time3: '22:34' },
			{ line: '2', time1: '22:53', time2: '23:00', time3: '23:12' },
		],
		vacation: [
			{ line: '1', time1: '06:14', time2: '06:45', time3: '06:57' },
			{ line: null, time1: null, time2: '07:00', time3: '07:12' },
			{ line: '2', time1: '06:19', time2: '07:20', time3: '07:32' },
			{ line: '1', time1: '08:10', time2: '08:17', time3: '08:29' },
			{ line: '2', time1: '08:33', time2: '08:45', time3: '08:53' },
			{ line: '1', time1: '09:25', time2: '09:35', time3: '09:43' },
			{ line: '2', time1: '10:15', time2: '10:22', time3: '10:32' },
			{ line: '7', time1: null, time2: '11:26', time3: '11:38' },
			{ line: '7', time1: null, time2: '12:36', time3: '12:48' },
			{ line: '2', time1: '13:29', time2: '13:36', time3: '13:48' },
			{ line: '7', time1: null, time2: '14:36', time3: '14:48' },
			{ line: '1', time1: '15:29', time2: '15:40', time3: '15:52' },
			{ line: '2', time1: '16:33', time2: '16:42', time3: '16:54' },
			{ line: '1', time1: '17:15', time2: '17:23', time3: '17:35' },
			{ line: '7', time1: null, time2: '17:45', time3: '17:57' },
			{ line: '1', time1: '17:57', time2: '18:10', time3: '18:22' },
			{ line: '6', time1: '18:37', time2: '18:45', time3: '18:57' },
			{ line: '6', time1: '19:35', time2: '19:44', time3: '19:56' },
			{ line: '1', time1: '22:13', time2: '22:22', time3: '22:34' },
		],
		holiday: [
			{ line: null, time1: null, time2: '07:00', time3: '07:12' },
			{ line: '1', time1: '08:10', time2: '08:20', time3: '08:32' },
			{ line: '2', time1: '08:34', time2: '08:45', time3: '08:53' },
			{ line: '1', time1: '10:15', time2: '10:22', time3: '10:32' },
			{ line: '7', time1: null, time2: '11:26', time3: '11:38' },
			{ line: '7', time1: null, time2: '12:36', time3: '12:48' },
			{ line: '7', time1: null, time2: '14:36', time3: '14:48' },
			{ line: '1', time1: '15:24', time2: '15:32', time3: '15:44' },
			{ line: '2', time1: '16:34', time2: '16:42', time3: '16:54' },
			{ line: '4-1', time1: '17:06', time2: '17:23', time3: '17:35' },
			{ line: '7', time1: null, time2: '17:45', time3: '17:57' },
			{ line: '1', time1: '17:49', time2: '18:06', time3: '18:18' },
			{ line: '1', time1: '18:34', time2: '18:45', time3: '18:57' },
			{ line: '6', time1: '19:35', time2: '19:44', time3: '19:56' },
			{ line: '2', time1: '20:11', time2: '20:24', time3: '20:36' },
			{ line: '1', time1: '20:59', time2: '21:20', time3: '21:32' },
			{ line: '1', time1: '22:04', time2: '22:18', time3: '22:30' },
		],
	},
};
export const ALERT_MESSAGE = Object.freeze({
	NO_FIND_STATION: '찾는 역이 없습니다.',
	SELECT_STATION:
		'버스를 탈 정류장을 선택하여 버스 도착 예정시간을 알아보세요.',
	SELECT_PLACE: '원하는 지점을 선택해주세요',
	ERROR_MESSAGE: `네트워크가 원활하지 않습니다. \n 다시 시도해주세요`,
});
